// extracted by mini-css-extract-plugin
module.exports = {"container":"ReflectionsTabIntroduction_container__PbD_C","title":"ReflectionsTabIntroduction_title__63Caq"};